import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Button,
  Checkbox,
  Typography,
  Autocomplete,
  FormControlLabel,
} from "@mui/material";

import {
  freightListforInvoiceCreation,
  branchList,
  freightInvoiceCreate,
  freightPrint,
  branchpartyList,
  dueFreightDelete,
  dueFreightUpdate,
} from "../../../Services/Services";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect } from "react";
import Popover from "@mui/material/Popover";
import PrintIcon from "@mui/icons-material/Print";
import { Edit, Delete } from "@mui/icons-material";
export default function FreightInvoice() {
  const [data, setData] = useState([]);
  const [deleteId, setDelete] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [editIndex, setEditIndex] = useState(null);
  const [selectedFreightIds, setSelectedFreightIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [branches, setBranches] = useState([]);
  const [showAppPaymentFields, setShowAppPaymentFields] = useState(false);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [partyOptions, setParties] = useState([]);
  const [branchOptions, setBranch] = useState([]);
  const [filters, setFilters] = useState({
    party_name: "",
    do_no: "",
    truck_no: "",
  });

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

const fetchFreightList = async (pageNum, activefilter = filters, append = false) => {
  const res = await freightListforInvoiceCreation(pageNum, activefilter);

  if (res && res.results) {
    if (append) {
      setData(prev => [...prev, ...res.results]);
    } else {
      setData(res.results);
    }

    // ✅ hasMore ko response ke hisaab se set karo
    setHasMore(!!res.next);
  } else {
    setHasMore(false);
  }
  return res;
};


useEffect(() => {
  const handler = setTimeout(() => {
    setPage(1);
    fetchFreightList(1, filters, false); // overwrite old data
  }, 500);
  return () => clearTimeout(handler);
}, [filters]);


const fetchMoreData = async () => {
  const nextPage = page + 1;
  const res = await fetchFreightList(nextPage, filters, true);

  if (res?.results?.length > 0) {
    setPage(nextPage);
  } else {
    setHasMore(false); // ✅ aur page nahi hai
  }
};
  const handleFilterChange = (key,value) => {
  setFilters((prev) => ({
    ...prev,   
    [key]: value,
  }))
}
  const branchListApi = async () => {
    try {
      const response = await branchList(); // don't pass any argument if not needed
      setBranches(response);
      console.log("Branches fetched successfully:", response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    branchListApi();
  }, []);

  const handleDelete = async (id) => {
    const del_data = await dueFreightDelete(id);
    setData(prevData =>
      prevData.filter(row => row.freight_id !== del_data.freight_id)
    );
  };
  const handleEditOpen = (row, index) => {
    setEditRow(row);
    setEditIndex(row.freight_id);
    setEditDialogOpen(true);
  };

const filteredData = (Array.isArray(data) ? data : []).filter((item) => {
  return (
    (!filters.do_no || item.do_no?.toString().includes(filters.do_no)) &&
    (!filters.truck_no || item.truck_no?.toString().includes(filters.truck_no)) &&
    (!filters.party_name || item.party_name?.toLowerCase().includes(filters.party_name.toLowerCase()))
  );
});


  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  const [formData, setFormData] = useState({
    branch_id: null,
    freight_id: [],
    total_amount: 0,
    pay_amount: "",
    payment_to: "",
    pay_mode: "",
    upi_check_no: "",
  });

  const handlePrintSingleRow = async (row) => {
    const data = await freightPrint(row.freight_id);

    const printWindow = window.open("", "", "width=900,height=600");

    const fieldPairs = [
      ["loading_date", "unloading_date"],
      ["from_location", "to_location"],
      ["do_no", "tp_no"],
      ["loading_wt", "received_wt"],
      ["shortage_wt", "billing_wt"],
      ["freight_rate", "freight_amt"],
      ["tds_per", "tds_amt"],
      ["total_advance", "commission"],
      ["shortage_rate", "shortage_amt"],
      ["net_amount", "other_exp"],
      ["net_payable", "truck_no"],
    ];
    row.payments = data[0] ? data[0].payments : [];
    row.freights = data[0] ? data[0].freights : [];
    const tableRows = fieldPairs.map(([key1, key2]) => {
      const value1 = row[key1] ?? "";
      const value2 = row[key2] ?? "";

      const formatTitle = (text) =>
        text
          .replace(/_/g, " ")
          .replace(
            /\w\S*/g,
            (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
          );

      const tdStyle = (hasKey) =>
        hasKey
          ? 'style="border:1px solid #000;padding:6px;width:22%;background-color:rgba(211, 211, 211, 0.42);"'
          : 'style="border:1px solid #000;padding:6px;width:22%;"';

      return `
        <tr>
          <td ${tdStyle(!!key1)}><strong>${key1 ? formatTitle(key1) : ""
        }</strong></td>
          <td style="border:1px solid #000;padding:6px;width:28%;">${value1}</td>
          <td style="width:2%;"></td>
          <td ${tdStyle(!!key2)}><strong>${key2 ? formatTitle(key2) : ""
        }</strong></td>
          <td style="border:1px solid #000;padding:6px;width:28%;">${value2}</td>
        </tr>
      `;
    });

    // Generate additional table with heading and multiple payment entries
    let additionalTableHTML = "";

    if (Array.isArray(row.freights) && row.freights.length > 0) {
      additionalTableHTML += `
      <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
        <thead>
          <tr>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Freight Id</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Truck No</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Load Wt</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Unload Wt </th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Net Payble</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Date</th>
          </tr>
        </thead>
        <tbody>
    `;

      row.freights.forEach((freight) => {
        additionalTableHTML += `
        <tr>
          <td style="text-align:center;">${freight.freight_id || ""}</td>
                  <td style="text-align:center;">${freight.truck_no || ""}</td>
          <td style="text-align:center;">${freight.loading_wt || ""}</td>
          <td style="text-align:center;">${freight.received_wt || ""}</td>
          <td style="text-align:center;">${freight.net_payable || ""}</td>
           <td style="text-align:center;">${formatOnlyDate(freight.created_at) || ""
          }</td>
        </tr>
      `;
      });

      additionalTableHTML += `
        </tbody>
      </table>
    `;
    }

    // If multiple payments exist

    if (Array.isArray(row.payments) && row.payments.length > 0) {
      additionalTableHTML += `
      <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
        <thead>
          <tr>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amt</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Pay Mode</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">UPI/Cheque No.</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Payment To</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Remark</th>
            </tr>
        </thead>
        <tbody>
    `;

      row.payments.forEach((payment) => {
        additionalTableHTML += `
        <tr>
          <td style="text-align:center;">${payment.pay_amount || ""}</td>
          <td style="text-align:center;">${payment.pay_mode || ""}</td>
          <td style="text-align:center;">${payment.upi_check_no || ""}</td>
          <td style="text-align:center;">${payment.payment_to || ""}</td>
           <td style="text-align:center;">${payment.remark || ""}</td>
        </tr>
      `;
      });

      additionalTableHTML += `
        </tbody>
      </table>
    `;
    }

    if (Array.isArray(data) && data.length > 0) {
      additionalTableHTML += `
      <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
        <thead>
          <tr>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Total Amount</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amount</th>
            <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Balance Amount</th>
            </tr>
        </thead>
        <tbody>
    `;

      data.forEach((payment) => {
        additionalTableHTML += `
        <tr>
          <td style="text-align:center;">${payment.total_amount || ""}</td>
          <td style="text-align:center;">${payment.paid_amount || ""}</td>
          <td style="text-align:center;">${payment.rem_amount || ""}</td>
        </tr>
      `;
      });

      additionalTableHTML += `
        </tbody>
      </table>
    `;
    }
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Freight Row</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            header {
              text-align: center;
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 20px;
              color: #333;
            }
            footer {
              position: fixed;
              bottom: 10px;
              width: 100%;
              text-align: center;
              font-size: 12px;
              color: #333;
            }
            table {
              border-collapse: collapse;
              width: 100%;
            }
            td {
              font-size: 14px;
              vertical-align: top;
            }
            th {
              background-color:rgba(211, 211, 211, 0.42);
              font-weight: bold;
            }
            td[style*="background-color"], th[style*="background-color"] {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          </style>
        </head>
        <body>
          <header>SR ENTERPRICES</header>
  
          <table border="1" style="border: 1px solid black; border-collapse: collapse;" cellpadding="5">
            <tr>
              <td>Ashutosh Ku. Singh</td>
              <td>Freight ID: ${row.freight_id}</td>
              <td>${row.truck_owner}</td>
            </tr>
            <tr>
              <td>Branch Name: ${row.branch_name}</td>
              <td>Net Payable : ${row.net_payable}</td>
              <td>${row.phone_no}</td>
            </tr>
          </table>
  
          <br>
  
          <table>
            ${tableRows.join("")}
          </table>
  
          <table border="1" style="border-collapse: collapse; width: 100%;" cellpadding="5">
            <tbody>
              ${additionalTableHTML}
            </tbody>
          </table>
  
          <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
  
          <script>
            window.onload = function () {
              window.print();
              window.onafterprint = function () {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const handleSubmit = async () => {
    const payAmount = parseFloat(formData.pay_amount || 0);
    const remAmount = netPayableTotal - payAmount;

    const payload = {
      branch_id: formData.branch_id,
      freight_id: selectedFreightIds, // Must match backend expected key
      total_amount: netPayableTotal,
      paid_amount: payAmount,
      rem_amount: remAmount,
      payments: formData.pay_amount
        ? [
          {
            pay_amount: formData.pay_amount,
            payment_to: formData.payment_to,
            upi_check_no: formData.upi_check_no,
            pay_mode: formData.pay_mode,
            remark: formData.description,
          },
        ]
        : null,
    };

    const response = await freightInvoiceCreate(payload);

    if (response) {
      setData(response);
      setFormData({
        branch_id: null,
        freight_id: [],
        total_amount: 0,
        pay_amount: "",
        payment_to: "",
        pay_mode: "",
        upi_check_no: "",
        description: "",
      });
      setSelectedFreightIds([]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedFreightIds([]);
      setSelectAll(false);
    } else {
      const allIds = filteredData.map((f) => f.freight_id);
      setSelectedFreightIds(allIds);
      setSelectAll(true);
    }
  };
  const handleRowSelect = (freight_id) => {
    let updated;
    if (selectedFreightIds.includes(freight_id)) {
      updated = selectedFreightIds.filter((id) => id !== freight_id);
    } else {
      updated = [...selectedFreightIds, freight_id];
    }
    setSelectedFreightIds(updated);
    setSelectAll(updated.length === filteredData.length);
  };
  const netPayableTotal = selectedFreightIds
    .reduce((acc, id) => {
      const row = filteredData.find((f) => f.freight_id === id);
      return acc + parseFloat(row?.net_payable || 0);
    }, 0)
    .toFixed(2);

  const handlePaymentchange = () => {
    setShowAppPaymentFields(!showAppPaymentFields);
    if (showAppPaymentFields) {
      setFormData((prev) => ({
        ...prev,
        pay_amount: "",
        payment_to: "",
        pay_mode: "",
        upi_check_no: "",
      }));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setEditRow((prev) => ({
      ...prev,
      is_remember: checked,
    }));
  };

  const handleEditChange = (field, value) => {
    const updatedData = { ...editRow, [field]: value };

    const loading =
      parseFloat(field === "loading_wt" ? value : updatedData.loading_wt) || 0;
    const receiving =
      parseFloat(field === "received_wt" ? value : updatedData.received_wt) ||
      0;
    const freightRate =
      parseFloat(field === "freight_rate" ? value : updatedData.freight_rate) ||
      0;
    const tdsRate =
      parseFloat(field === "tds_per" ? value : updatedData.tds_per) || 0;
    const shortageRate =
      parseFloat(
        field === "shortage_rate" ? value : updatedData.shortage_rate
      ) || 0;
    const commission =
      parseFloat(field === "commission" ? value : updatedData.commission) || 0;
    const minesAdvance =
      parseFloat(field === "ad_mines_exp" ? value : updatedData.ad_mines_exp) ||
      0;
    const dieselAdvance =
      parseFloat(
        field === "ad_diesel_exp" ? value : updatedData.ad_diesel_exp
      ) || 0;
    const cashAdvance =
      parseFloat(field === "ad_cash_exp" ? value : updatedData.ad_cash_exp) ||
      0;
    const otherExp =
      parseFloat(field === "other_exp" ? value : updatedData.other_exp) || 0;

    // Billing Wt
    updatedData.billing_wt = Math.min(loading, receiving).toFixed(2);

    // Shortage Wt
    const shortage = (loading - receiving) * 1000;
    updatedData.shortage_wt = shortage > 0 ? shortage.toFixed(2) : "0";

    // Freight Amount
    const billing = parseFloat(updatedData.billing_wt) || 0;
    updatedData.freight_amt = (freightRate * billing).toFixed(2);

    // TDS Amount
    const tdsAmt = (parseFloat(updatedData.freight_amt) * tdsRate) / 100;
    updatedData.tds_amt = tdsAmt.toFixed(2);

    // Shortage Amount
    updatedData.shortage_amt = (
      parseFloat(updatedData.shortage_wt) * shortageRate
    ).toFixed(2);

    // Total Advance
    updatedData.total_advance = (
      minesAdvance +
      dieselAdvance +
      cashAdvance
    ).toFixed(2);

    // Net Amount
    updatedData.net_amount = (
      parseFloat(updatedData.freight_amt) -
      parseFloat(updatedData.tds_amt) -
      parseFloat(updatedData.shortage_amt) -
      parseFloat(updatedData.total_advance) -
      commission
    ).toFixed(2);

    // Net Payable
    updatedData.net_payable = (
      parseFloat(updatedData.net_amount) - otherExp
    ).toFixed(2);

    setEditRow(updatedData);
  };

  const handleEditSave = async () => {
    if (editRow.receive_amount === '') {
      editRow.receive_amount = 0;
    }
    editRow.bal_amount = (parseFloat(editRow.net_payable) - parseFloat(editRow.paid_amount)).toFixed(2);

    const res_data = await dueFreightUpdate(editRow.freight_id, editRow);
    setData(prevData =>
      prevData.map(row =>
        row.freight_id === res_data.freight_id ? res_data : row
      )
    );

    setEditDialogOpen(false);
  };

  return (
    <div style={{ maxHeight: "calc(100vh - 70px)",  }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          py: 1,
          px: 1,

        }}
      >
        <TextField
          fullWidth
          label="Filter by Party Name"
          variant="outlined"
          size="small"
          value={filters.party_name}
          onChange={(e) => handleFilterChange("party_name",e.target.value)}
          sx={{ flex: "1 1 200px", "& .MuiInputBase-root": { height: "35px" }, marginTop: -3, }}
        />
        <TextField
          fullWidth
          label="Do No"
          variant="outlined"
          size="small"
          value={filters.do_no}
          onChange={(e) => handleFilterChange("do_no",e.target.value)}
          sx={{ flex: "1 1 100px", "& .MuiInputBase-root": { height: "35px" }, marginTop: -3 }}
        />
        <TextField
          fullWidth
          label=" Truck No"
          variant="outlined"
          size="small"
          value={filters.truck_no}
          onChange={(e) => handleFilterChange("truck_no",e.target.value)}
          sx={{ flex: "1 1 100px", "& .MuiInputBase-root": { height: "35px" }, marginTop: -3 }}
        />
      </Box>
      {/* <br/> */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // Perform any validations here if needed
          handleSubmit();
        }}
      >
        <Grid container spacing={3} py={2} alignItems="center">
          <Grid item xs={4}>
            <Autocomplete
              options={branches}
              getOptionLabel={(option) => option?.branch_name || ""}
              value={
                branches.find((b) => b.branch_id === formData.branch_id) || null
              }
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  branch_id: newValue?.branch_id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Branch Name"
                  variant="outlined"
                  size="medium"
                  required
                  sx={{
                    "& .MuiInputBase-root": { height: "35px" },
                    "& .MuiInputLabel-root": {
                      lineHeight: "10px",
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              label="Total Net Payable"
              value={netPayableTotal}
              InputProps={{ readOnly: true }}
              fullWidth
              size="small"
              sx={{ "& .MuiInputBase-root": { height: "35px" } }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Selected Freight"
              value={selectedFreightIds.length}
              InputProps={{ readOnly: true }}
              fullWidth
              size="small"
              sx={{ "& .MuiInputBase-root": { height: "35px" } }}
            />
          </Grid>

          <Grid item xs={3} textAlign="right">
            <Button
              variant="outlined"
              onClick={handlePaymentchange}
              sx={{ mr: 2, height: "35px" }}
              startIcon={
                <span className="material-icons">
                  {showAppPaymentFields ? "close" : "add"}
                </span>
              }
            >
              Payment
            </Button>
            {/* The Save button now submits the form */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ height: "35px" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>

        {/* <br /> */}

        {showAppPaymentFields && (
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            spacing={2}
          >
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="pay_amount"
                label="Pay Amount"
                type="number"
                value={formData.pay_amount}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="payment_to"
                label="Payment To"
                value={formData.payment_to}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="pay_mode"
                label="Payment Mode"
                value={formData.pay_mode}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="upi_check_no"
                label="UPI / Cheque No."
                value={formData.upi_check_no}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="description"
                label="Payment Description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </Grid>
          </Grid>
        )}
      </form>

      <br />

  <InfiniteScroll
          dataLength={data.length}
          next={fetchMoreData}
          hasMore={hasMore}
          scrollableTarget="scrollableDiv"
           scrollThreshold={0.8}
        >
      <TableContainer
        id="scrollableDiv"
        sx={{ maxHeight: "70vh", overflow: "auto" }}>
      
          {/* <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}> */}
          {/* <div style={{ maxHeight: "75vh", overflowX: "auto" }}> */}
          <Table
            stickyHeader // ✅ THIS makes the header sticky
            size="small"
            sx={{
              tableLayout: "auto",
              width: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "4px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableCell
                  className="no-export"
                  sx={{
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                  }}
                  padding="checkbox"
                >
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    size="small"
                  />
                </TableCell>
                <TableCell>SR. No</TableCell>
                <TableCell>Freight Id</TableCell>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 52,
                    zIndex: 3,
                  }}
                >
                  Truck No.
                </TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>Loading Date</TableCell>
                <TableCell>Unloading Date</TableCell>

                <TableCell>D.O. No.</TableCell>
                <TableCell className="no-print">T.P. No.</TableCell>
                <TableCell>From</TableCell>
                <TableCell>To</TableCell>
                <TableCell>Loading Wt</TableCell>
                <TableCell>Receiving Wt</TableCell>
                <TableCell>Shortage Wt</TableCell>
                <TableCell>Billing Wt</TableCell>
                <TableCell>Freight Rate</TableCell>
                <TableCell>Freight Amt</TableCell>
                <TableCell className="no-print">TDS %</TableCell>
                <TableCell>TDS Amt</TableCell>
                <TableCell>Shortage Rate</TableCell>
                <TableCell>Shortage Amt</TableCell>
                <TableCell className="no-print">Ad Mines</TableCell>
                <TableCell className="no-print">Ad Diesel</TableCell>
                <TableCell className="no-print">Ad Cash</TableCell>
                <TableCell>Total Ad</TableCell>
                <TableCell>Commission</TableCell>
                <TableCell>Net Amt</TableCell>
                <TableCell>Others Exp.</TableCell>
                <TableCell>Net Payable</TableCell>
                <TableCell>Paid Amt</TableCell>
                <TableCell>Bal Amt</TableCell>
                <TableCell className="no-print">Truck Owner</TableCell>
                <TableCell className="no-print">Phone No.</TableCell>
                <TableCell className="no-print">PAN No.</TableCell>
                <TableCell className="no-print">Remark</TableCell>
                <TableCell>Date</TableCell>
                <TableCell
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#f5f5f5",
                    zIndex: 2,
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={32} align="center">
                    No matching records found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: row.is_remember
                        ? "#ffe0b2"
                        : index % 2 === 0
                          ? "#fafafa"
                          : "#ffffff",
                      "& td": {
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                      }}
                      padding="checkbox"
                    >
                      <Checkbox
                        checked={selectedFreightIds.includes(row.freight_id)}
                        onChange={() => handleRowSelect(row.freight_id)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.freight_id}</TableCell>
                    <TableCell sx={{ position: "sticky", left: 52 }}>
                      {row.truck_no}
                    </TableCell>
                    <TableCell>{row.party_name}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>{row.loading_date}</TableCell>
                    <TableCell>{row.unloading_date}</TableCell>

                    <TableCell>{row.do_no}</TableCell>
                    <TableCell className="no-print">{row.tp_no}</TableCell>
                    <TableCell>{row.from_location}</TableCell>
                    <TableCell>{row.to_location}</TableCell>
                    <TableCell>{row.loading_wt}</TableCell>
                    <TableCell>{row.received_wt}</TableCell>
                    <TableCell>{row.shortage_wt}</TableCell>
                    <TableCell>{row.billing_wt}</TableCell>
                    <TableCell>{row.freight_rate}</TableCell>
                    <TableCell>{row.freight_amt}</TableCell>
                    <TableCell className="no-print">{row.tds_per}</TableCell>
                    <TableCell>{row.tds_amt}</TableCell>
                    <TableCell>{row.shortage_rate}</TableCell>
                    <TableCell>{row.shortage_amt}</TableCell>
                    <TableCell className="no-print">
                      {row.ad_mines_exp}
                    </TableCell>
                    <TableCell className="no-print">
                      {row.ad_diesel_exp}
                    </TableCell>
                    <TableCell className="no-print">
                      {row.ad_cash_exp}
                    </TableCell>
                    <TableCell>{row.total_advance}</TableCell>
                    <TableCell>{row.commission}</TableCell>
                    <TableCell>{row.net_amount}</TableCell>
                    <TableCell>{row.other_exp}</TableCell>
                    <TableCell>{row.net_payable}</TableCell>
                    <TableCell>{row.paid_amount}</TableCell>
                    <TableCell>{row.bal_amount}</TableCell>
                    <TableCell className="no-print">
                      {row.truck_owner}
                    </TableCell>
                    <TableCell className="no-print">{row.phone_no}</TableCell>
                    <TableCell className="no-print">{row.pan_no}</TableCell>
                    <TableCell className="no-print">{row.remark}</TableCell>
                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => handleEditOpen(row, row.freight_id)}
                        >
                          <Edit fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color="error"
                          onClick={(event) => {
                            setAnchorEl1(event.currentTarget);
                            setDelete(row.freight_id);
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handlePrintSingleRow(row)}
                        >
                          <PrintIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
            <TableRow
              sx={{
                backgroundColor: "#e3f2fd",
                fontWeight: "bold",
              }}
            >
              <TableCell colSpan={12} align="right">
                Total:
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.loading_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.received_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.shortage_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.billing_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.freight_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center"></TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.tds_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.shortage_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center" colSpan={2}></TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.total_advance || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.commission || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.net_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.other_exp || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.net_payable || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.paid_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.bal_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center" colSpan={6}></TableCell>
            </TableRow>
          </Table>
          {/* </div> */}
          {/* </TableContainer> */}
        
      </TableContainer></InfiniteScroll>
      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Edit Freight Record</DialogTitle>

        <DialogContent>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={editRow.is_remember}
                  onChange={handleCheckboxChange}
                />
              }
              label="Remember"
            />
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={3}>
              <Autocomplete
                options={partyOptions}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  partyOptions.find((opt) => opt.name === editRow.party_name) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleEditChange("party_id", newValue?.party_id || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Party Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={3}>
              <Autocomplete
                options={branchOptions}
                getOptionLabel={(option) => option?.branch_name || ""}
                value={
                  branchOptions.find(
                    (opt) => opt.branch_name === editRow.branch_name
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleEditChange("branch_id", newValue?.branch_id || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Branch Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="From Location"
                fullWidth
                value={editRow.from_location || ""}
                onChange={(e) =>
                  handleEditChange("from_location", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="To Location"
                fullWidth
                value={editRow.to_location || ""}
                onChange={(e) =>
                  handleEditChange("to_location", e.target.value)
                }
              />
            </Grid>

            {/* 2nd Row */}
            <Grid item xs={3}>
              <TextField
                label="Loading Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={editRow.loading_date || ""}
                onChange={(e) =>
                  handleEditChange("loading_date", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Unloading Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={editRow.unloading_date || ""}
                onChange={(e) =>
                  handleEditChange("unloading_date", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="Truck No"
                fullWidth
                value={editRow.truck_no || ""}
                onChange={(e) => handleEditChange("truck_no", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Truck Owner"
                fullWidth
                value={editRow.truck_owner || ""}
                onChange={(e) =>
                  handleEditChange("truck_owner", e.target.value)
                }
              />
            </Grid>

            {/* 3rd Row */}
            <Grid item xs={3}>
              <TextField
                label="Phone No."
                fullWidth
                value={editRow.phone_no || ""}
                onChange={(e) => handleEditChange("phone_no", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="PAN No"
                fullWidth
                value={editRow.pan_no || ""}
                onChange={(e) => handleEditChange("pan_no", e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="TP No"
                fullWidth
                value={editRow.tp_no || ""}
                onChange={(e) => handleEditChange("tp_no", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="DO No"
                fullWidth
                value={editRow.do_no || ""}
                onChange={(e) => handleEditChange("do_no", e.target.value)}
              />
            </Grid>

            {/* 4th Row */}
            <Grid item xs={3}>
              <TextField
                label="Loading Wt"
                fullWidth
                value={editRow.loading_wt || ""}
                onChange={(e) => handleEditChange("loading_wt", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Receiving Wt"
                fullWidth
                value={editRow.received_wt || ""}
                onChange={(e) =>
                  handleEditChange("received_wt", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="Shortage Wt"
                fullWidth
                value={editRow.shortage_wt || ""}
                onChange={(e) =>
                  handleEditChange("shortage_wt", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Billing Wt"
                fullWidth
                value={editRow.billing_wt || ""}
                onChange={(e) => handleEditChange("billing_wt", e.target.value)}
              />
            </Grid>

            {/* 5th Row */}
            <Grid item xs={3}>
              <TextField
                label="Freight Rate"
                fullWidth
                value={editRow.freight_rate || ""}
                onChange={(e) =>
                  handleEditChange("freight_rate", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Freight Amount"
                fullWidth
                value={editRow.freight_amt || ""}
                onChange={(e) =>
                  handleEditChange("freight_amt", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="Shortage Rate"
                fullWidth
                value={editRow.shortage_rate || ""}
                onChange={(e) =>
                  handleEditChange("shortage_rate", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Shortage Amount"
                fullWidth
                value={editRow.shortage_amt || ""}
                onChange={(e) =>
                  handleEditChange("shortage_amt", e.target.value)
                }
              />
            </Grid>

            {/* 6th Row */}
            <Grid item xs={3}>
              <TextField
                label="TDS (%)"
                fullWidth
                value={editRow.tds_per || ""}
                onChange={(e) => handleEditChange("tds_per", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="TDS Amount"
                fullWidth
                value={editRow.tds_amt || ""}
                onChange={(e) => handleEditChange("tds_amt", e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="Ad Mines"
                fullWidth
                value={editRow.ad_mines_exp || ""}
                onChange={(e) =>
                  handleEditChange("ad_mines_exp", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Ad Diesel"
                fullWidth
                value={editRow.ad_diesel_exp || ""}
                onChange={(e) =>
                  handleEditChange("ad_diesel_exp", e.target.value)
                }
              />
            </Grid>

            {/* 7th Row */}
            <Grid item xs={3}>
              <TextField
                label="Ad Cash"
                fullWidth
                value={editRow.ad_cash_exp || ""}
                onChange={(e) =>
                  handleEditChange("ad_cash_exp", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Total Advance"
                fullWidth
                value={editRow.total_advance || ""}
                onChange={(e) =>
                  handleEditChange("total_advance", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                label="Commission"
                fullWidth
                value={editRow.commission || ""}
                onChange={(e) => handleEditChange("commission", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Net Amount"
                fullWidth
                value={editRow.net_amount || ""}
                onChange={(e) => handleEditChange("net_amount", e.target.value)}
              />
            </Grid>

            {/* 8th Row */}
            <Grid item xs={3}>
              <TextField
                label="Others Exp."
                fullWidth
                value={editRow.other_exp || ""}
                onChange={(e) => handleEditChange("other_exp", e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Net Payable"
                fullWidth
                value={editRow.net_payable || ""}
                onChange={(e) =>
                  handleEditChange("net_payable", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Remark"
                fullWidth
                value={editRow.remark || ""}
                onChange={(e) => handleEditChange("remark", e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>

              <TextField
                label="Hisab Amount"
                fullWidth
                type="number"
                value={editRow.receive_amount || 0}
                onChange={(e) => handleEditChange("receive_amount", e.target.value)}
                disabled={!editRow.is_bill}
              />

            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Difference Amount"
                fullWidth
                value={(editRow.net_amount - editRow.receive_amount).toFixed(2) || ""}
                onChange={(e) => handleEditChange("difference_amount", e.target.value)}
                disabled
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Remark for Payment"
                fullWidth
                value={editRow.payment_remark || ""}
                onChange={(e) => handleEditChange("payment_remark", e.target.value)}
                disabled={!editRow.is_bill}
              />
            </Grid>

          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(anchorEl1)}
        anchorEl={anchorEl1}
        onClose={() => {
          setAnchorEl1(null);
          setDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure ?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(deleteId);
                } finally {
                  setAnchorEl1(null);
                  setDelete(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl1(null);
                setDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
}